<div class="flex flex-wrap">
  <div class="relative w-full lg:w-5/12 authBackground hidden lg:block">
    <app-carousel></app-carousel>
  </div>

  <div class="relative w-full lg:w-7/12">
    <div class="login-card">
      <div class="login-main">
        @if(isLogin()) {
        <app-oauth-login (loggedIn)="onLoggedIn($event)"></app-oauth-login>
        } @else {
        <app-otp
          [isCodeHidden]="false"
          [status]=""
          [channelValue]="channelValue()"
          (verified)="onVerified($event)"
          (goBack)="isLogin.set(true)"
        ></app-otp>
        }
      </div>
    </div>
  </div>
</div>
